'use client'
import popularHotelsData from '@/src/constants/hotels/homePopularHotels.json'
import { useFeatures } from '@/src/hooks/useFeatures'
import { useLocale, useTranslations } from 'next-intl'
import { useMemo } from 'react'
import PopularHotels, { PopularHotel } from './popularHotels'

// Static "35% off" promo, ported verbatim from me-flyin's popular-hotels template.
const PROMO_PERCENT = 35

// Logic layer: resolves the localized popular-hotels list (ported from me-flyin's
// getPopularHotels static data) and the section/badge labels.
const PopularHotelsWrapper: React.FC = () => {
    const t = useTranslations('homePage.headings')
    const locale = useLocale()
    const isArabic = locale === 'ar'
    const { POPULAR_HOTELS } = useFeatures()

    const hotels = useMemo<PopularHotel[]>(
        () =>
            popularHotelsData.hotels.map(hotel => ({
                id: hotel.id,
                name: isArabic ? hotel.name_ar || hotel.name_en : hotel.name_en,
                location: isArabic ? hotel.location_ar || hotel.location_en : hotel.location_en,
                rating: hotel.rating,
                luxury: hotel.luxury,
                imageUrl: hotel.imageUrl,
                href: isArabic ? hotel.href_ar || hotel.href_en : hotel.href_en
            })),
        [isArabic]
    )

    if (!POPULAR_HOTELS || hotels.length === 0) return null

    return (
        <PopularHotels
            title={t('popularHotels')}
            luxuryLabel={t('luxuryHotel')}
            offLabel={t('percentOff', { percent: PROMO_PERCENT })}
            hotels={hotels}
        />
    )
}

export { PopularHotelsWrapper }
export default PopularHotelsWrapper
